import type {FetchCitizenshipsQuery, FetchCitizenshipsResponse} from '../../http';
import {fetchCitizenships} from '../../http';
import {useQuery, type UseQueryOptions} from 'react-query';

const defaultQuery: FetchCitizenshipsQuery = {};

export function useFetchCitizenships(
	query?: FetchCitizenshipsQuery,
	options?: UseQueryOptions<FetchCitizenshipsResponse>,
) {
	const q = query ?? defaultQuery;

	return useQuery<FetchCitizenshipsResponse>({
		queryKey: ['citizenships', q],
		queryFn: async ({signal}) => {
			const {data} = await fetchCitizenships(q, signal);

			return data;
		},
		staleTime: 60 * 60 * 1000,
		...options,
	});
}
